import { AccountLinkingBanner } from "app/modules/system/banners/accountLinking/AccountLinkingBanner";
import { CPLMaintenanceNotification } from "app/system/maintenance/MaintenanceBanners";
import { APIStatusBanner } from "app/system/apiStatus/APIStatusBanner";
import { ImpersonationBanner } from "app/modules/auth/impersonation/components/ImpersonationBanner";

export function HeaderNotifications() {
  return (
    <div id="header-notification-container" className="container">
      {<AccountLinkingBanner />}
      <CPLMaintenanceNotification />
      <APIStatusBanner />
      <ImpersonationBanner />
    </div>
  );
}
